<template>
  <div>
    <h3>Add a New Card</h3>
    <div ref="cardElement" class="card-element"></div>
    <div v-if="clientSecret">
      <div ref="cardElement" class="card-element"></div>
      <button
        :disabled="loading"
        class="save-card-button"
        @click="confirmCardSetup"
      >
        {{ loading ? 'Saving...' : '💾 Save Card' }}
      </button>
    </div>
    <div v-else>
      <p>Loading payment form...</p>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="success">✅ Card saved!</p>

    <hr />

    <h3>Saved Cards</h3>
    <ul>
      <li v-for="pm in paymentMethods" :key="pm.id">
        •••• {{ pm.card.last4 }} (Exp {{ pm.card.exp_month }}/{{ pm.card.exp_year }})<br/>
        default: {{ pm.is_default }}
        <span v-if="!pm.is_default">
          <button @click="setDefaultPaymentMethod(pm.id)">set default</button>
          <button @click="deletePaymentMethod(pm.id)">delete</button>
        </span>

      </li>
    </ul>
    <h3>Products</h3>
    {{ products }}
    <ul>
      <li v-for="pd in products" :key="pd.id">
        {{ pd }}
      </li>
    </ul>
    <h3>Subscriptions</h3>
    <pre>{{ subscriptions }}</pre>
    <ul>
      <li
        v-for="subscription in subscriptions"
        :key="subscription.id"
        class="subscription-card"
      >
        <h2>Subscription ID: {{ subscription.id }}</h2>
        <p><strong>Status:</strong> {{ subscription.status }}</p>
        <p><strong>Billing Method:</strong> {{ subscription.collection_method }}</p>
        <p><strong>Start Date:</strong> {{ formatDate(subscription.start_date) }}</p>
        <p v-if="subscription.cancel_at">
          <strong>Cancel Date:</strong> {{ formatDate(subscription.cancel_at) }}
        </p>
        <p v-else>
          <button @click="changeSubscription(subscription.id, 'price_1RYB07Cv4aPyX9tR3WTDCE3w')">upgrade</button>
        </p>
        <h3>Plan Details</h3>
        <div v-for="item in subscription.items.data" :key="item.id" class="plan">
          <p><strong>Product:</strong> {{ productInfo(item.plan.product).name }}</p>
          <p><strong>Amount:</strong> {{ formatAmount(item.price.unit_amount, item.price.currency) }}</p>
          <p><strong>Interval:</strong> Every {{ item.price.recurring.interval_count }} {{ item.price.recurring.interval }}</p>
          <p><strong>Quantity:</strong> {{ item.quantity }}</p>
        </div>
      </li>
    </ul>
    <h3 v-if="upcoming_subscriptions.length">Upcoming Subscriptions</h3>
    <pre>{{ upcoming_subscriptions }}</pre>

    <h3>Subscription Schedules</h3>
    {{subscription_schedules}}
    <div v-for="schedule in subscription_schedules" :key="schedule.id" class="schedule-card">
      <h4>Schedule ID: {{ schedule.id }}</h4>
      <p>Status: {{ schedule.status }}</p>

      <div v-for="(phase, index) in schedule.phases" :key="index" class="phase">
        <h5>Phase {{ index + 1 }}</h5>
        <p>Start: {{ formatDate(phase.start_date) }}</p>
        <p>End: {{ formatDate(phase.end_date) }}</p>

        <div v-for="item in phase.items" :key="item.price">
          <p><strong>Product:</strong> {{ item.price_data?.product?.name || 'Unknown' }}</p>
          <p><strong>Amount:</strong> {{ formatAmount(item.price_data?.unit_amount, item.price_data?.currency) }}</p>
          <p><strong>Interval:</strong> Every {{ item.price_data?.recurring?.interval_count }} {{ item.price_data?.recurring?.interval }}</p>
        </div>
      </div>
    </div>

    <h3>Invoices</h3>
    {{ invoices }}

    <h3>Payments</h3>
    {{ payments }}



  </div>
</template>

<script>
/* global Stripe */

import PaymentsAPIService from "@/servicehandlers/PaymentsAPIService";
const paymentsAPIService = new PaymentsAPIService();

export default {
  props: {
  },

  data() {
    return {
      stripe: null,
      stripeKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      elements: null,
      card: null,
      clientSecret: 123123,
      error: null,
      success: false,
      loading: false,
      paymentMethods: [],
      products: [],
      subscriptions: [],
      subscription_schedules: [],
      upcoming_subscriptions: [],
      invoices: [],
      payments: [],
      access_token: null,
      apiUrl: process.env.VUE_APP_API_URL,
    }
  },
  mounted() {
    this.access_token = localStorage.getItem('access_token')
    if (!window.Stripe) {
      const script = document.createElement('script')

      script.src = 'https://js.stripe.com/v3/'
      script.onload = this.initStripe
      document.head.appendChild(script)
    } else {
      this.initStripe()
    }
  },
  methods: {
    async initStripe() {
      this.stripe = Stripe(this.stripeKey)
      //console.log(JSON.stringify(this.stripe,null,2))
      this.elements = this.stripe.elements()
      this.card = this.elements.create('card')
      this.card.mount(this.$refs.cardElement)
      await this.getSetupIntent()
      await this.loadPaymentMethods()
      await this.loadProducts()
      await this.loadSubscriptions()
      await this.loadSubscriptionSchedules()
      await this.loadUpcomingSubscriptions()
      await this.loadInvoices()
      await this.loadPayments()
    },
    productInfo(productId) {
      return this.products.find( (p) => p.id === productId) || null
    },
    async getSetupIntent() {
      try {
        const response = await paymentsAPIService.getIntents(this.$router)
        this.clientSecret = response.clientSecret
      } catch (error) {
        console.error("problem getting intent", error)
        this.clientSecret = ''
      }
    },
    async confirmCardSetup() {
      this.loading = true
      this.error = null
      this.success = false

      const result = await this.stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: { name: '' }
        }
      })

      console.log('Card Setup Results:', result)

      if (result.error) {
        this.error = result.error.message
      } else {
        this.success = true
        await this.loadPaymentMethods()
        await this.getSetupIntent()
      }

      this.loading = false
    },

    async loadPaymentMethods() {
      try {
        const response = await paymentsAPIService.getPaymentMethods(this.$router)
        this.paymentMethods = response || []
      } catch (error) {
        this.paymentMethods = []  // fallback if API call fails
      }
    },

    async loadProducts() {
      try {
        const response = await paymentsAPIService.getProducts(this.$router)
        this.products = response || []
      } catch (error) {
        this.products = []  // fallback if API call fails
      }
    },
    async loadSubscriptions() {
      try {
        const response = await paymentsAPIService.getSubscriptions(this.$router)
        this.subscriptions = response || []
      } catch (error) {
        this.subscriptions = []  // fallback if API call fails
      }
    },
    async loadSubscriptionSchedules() {
      try {
        const response = await paymentsAPIService.getSubscriptionSchedules(this.$router)
        this.subscription_schedules = response || []

        await this.loadPriceDetailsForSchedules()
      } catch (error) {
        this.subscription_schedules = []  // fallback if API call fails
      }
    },
    async loadPriceDetailsForSchedules() {
      const uniquePriceIds = new Set()

      // Collect all unique price IDs from all phases
      this.subscription_schedules.forEach(schedule => {
        schedule.phases.forEach(phase => {
          phase.items.forEach(item => {
            if (item.price) uniquePriceIds.add(item.price)
          })
        })
      })

      const priceIdList = Array.from(uniquePriceIds)
      const priceDataMap = {}

      // Get details for each price
      for (const priceId of priceIdList) {
        try {
          const price = await paymentsAPIService.getPrice(priceId, this.$router)
          priceDataMap[priceId] = price
        } catch (e) {
          console.error(`Failed to load price ${priceId}`, e)
        }
      }

      // Attach price data back to the schedule phases
      this.subscription_schedules.forEach(schedule => {
        schedule.phases.forEach(phase => {
          phase.items.forEach(item => {
            item.price_data = priceDataMap[item.price] || null
          })
        })
      })
    },

    async loadUpcomingSubscriptions() {
      try {
        const response = await paymentsAPIService.getUpcomingSubscriptions(this.$router)
        this.upcoming_subscriptions = response || []
      } catch (error) {
        this.upcoming_subscriptions = []  // fallback if API call fails
      }
    },

    async loadInvoices() {
      try {
        const response = await paymentsAPIService.getInvoices(this.$router)
        this.invoices = response || []
      } catch (error) {
        this.invoices = []  // fallback if API call fails
      }
    },
    async loadPayments() {
      try {
        const response = await paymentsAPIService.getPayments(this.$router)
        console.log('PAYMENTS SUCCEEDED')
        this.payments = response || []
      } catch (error) {
        console.log('PAYMENTS FAILED', error)
        this.payments = []  // fallback if API call fails
      }
    },
    async changeSubscription(currentSubscriptionId, newPriceId) {

      try {
        await paymentsAPIService.changeSubscription({ currentSubscriptionId, newPriceId }, this.$router)
        await this.loadSubscriptions()
        await this.loadUpcomingSubscriptions()
      } catch (error) {
        console.log('Error changing Subscription', error)
      }

    } ,
    async setDefaultPaymentMethod( paymentMethodId ) {

      try {
        await paymentsAPIService.setDefaultPaymentMethod({ paymentMethodId }, this.$router)
        await this.loadPaymentMethods()
      } catch (error) {
        console.error('error setting default payment method', error)
      }

    },

    async deletePaymentMethod( paymentMethodId ) {
      try {
        await paymentsAPIService.deletePaymentMethod({ paymentMethodId }, this.$router)
        await this.loadPaymentMethods()
      } catch (error) {
        console.error('error deleting payment method', error)
      }

    },

    formatDate(unixTimestamp) {
      const date = new Date(unixTimestamp * 1000)

      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    formatAmount(amount, currency) {
      if (amount === null) return 'N/A'

      return `${(amount / 100).toFixed(2)} ${currency}`
    }
  }
}
</script>

<style scoped>
div {
  color: white!important;
  horiz-align: left;
}


</style>
